// Fixed-point macros — fix = signed 16-bit, fix32 = signed 32-bit, 5 fractional bits.
// game/ht.h:913-936. Callers that store a result into a `fix` field must wrap with s16()
// (the C++ truncates on store); the raw values here are the fix32 expression results.

import { idiv } from './int32.ts';

// game/ht.h:920 `#define itofx(x) ((x) << 5)`
export const itofx = (x: number): number => (x << 5) | 0;

// game/ht.h:925 `#define fxtoi(x) ((x) >> 5)` — arithmetic shift, signed
export const fxtoi = (x: number): number => x >> 5;

// game/ht.h:929 `#define mulfx(x, y) ((((fix32)(x)) * (y)) >> 5)`
// fix operands are 16-bit so the 32-bit product is exact; >> is arithmetic.
export const mulfx = (x: number, y: number): number => Math.imul(x, y) >> 5;

// game/ht.h:931 `#define divfx(x, y) ((((fix32)(x)) << 5) / (y))` — C++ integer division
// truncates toward zero.
export const divfx = (x: number, y: number): number => idiv((x << 5) | 0, y);

// game/ht.h:933 `#define addfx(x, y) ((fix)(x) + (fix)(y))`
export const addfx = (x: number, y: number): number => (x + y) | 0;

// game/ht.h:935 `#define subfx(x, y) ((x) - (y))`
export const subfx = (x: number, y: number): number => (x - y) | 0;

// game/ht.h:936 `#define fracfx(x) ((x) & ((1 << FRACBITS) - 1))`
export const fracfx = (x: number): number => x & 0x1f;
